/**
 * Scoped Storage System
 * 
 * Provides device and user-scoped storage for app settings.
 * Settings are scoped by userId + deviceId so that:
 * - Same user on different devices → different settings
 * - Different users on same device → different settings
 */

export { DeviceIdentifier, deviceIdentifier } from './DeviceIdentifier';
export { ScopedStorageKeyBuilder } from './ScopedStorageKeyBuilder';
export type { ScopedKeyComponents } from './ScopedStorageKeyBuilder';
export { ScopedAsyncStorage } from './ScopedAsyncStorage';
export {
  UserDeviceProvider,
  useScopedStorage,
  useScopedStorageReady,
  useStorageScope,
  useRequiredScopedStorage,
} from './UserDeviceContext';
export type { StorageScope } from './UserDeviceContext';
export { StorageMigrationManager } from './StorageMigrationManager';
export type { MigrationResult } from './StorageMigrationManager';
export { StorageInitializer } from './StorageInitializer';
